export const StandardPageLayout = ({ children }: { children: React.ReactNode }) => {
    return <main className="container mx-auto max-w-7xl px-4 sm:px-6 grow pt-6">{children}</main>;
};
